/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".simple-search-container[_ngcontent-%COMP%]{height:100%;display:block!important}.simple-search-container[_ngcontent-%COMP%]   .fields-container[_ngcontent-%COMP%]{overflow:auto;max-height:500px}.simple-search-container[_ngcontent-%COMP%]   .search-button[_ngcontent-%COMP%]{width:100%}"];
export { styles as styles };
